import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { ITimeline } from "../../interfaces/itimeline";
import { AuthService } from "../../services/auth.service";

@Component({
    selector: "events",
    templateUrl: "./events.component.html",
    standalone: false
})
export class EventsComponent {
    timeline: ITimeline;
    searchTerm: string = "";
    countryInformationRouteLink: string = "";
    constructor(private activatedRoute: ActivatedRoute) {
        this.timeline = activatedRoute.snapshot.data['events'] as ITimeline;
        this.countryInformationRouteLink = `${AuthService.businessFunction?.defaultRoute || ""}/countryinformation/`;
    }
}